import React, { useContext } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { lang } from '@lib/constants'

import NavHeightContext from '@context/NavHeightContext'

import urls from '@data/i18n/urls.json'
import { signOut } from 'next-auth/react'

export default function SubNav() {
	const router = useRouter()
	const navHeightContext = useContext(NavHeightContext)

	if (!navHeightContext) {
		throw new Error('SubNav must be used within a NavHeightContext.Provider')
	}
	const { navHeight } = navHeightContext

	return (
		<header
			className="sticky z-[21] border-b border-gray-200 bg-white"
			style={{ top: `${navHeight}px` }}
		>
			<div className="bg-bbx-pearl-lightest w-full">
				<nav className="container flex justify-between items-center">
					<div className="flex flex-nowrap overflow-x-auto overflow-y-hidden scrollbar-none">
						<Link href={urls.subNav.subscriptions.url} prefetch={false} className="relative">
							<span
								className={`px-6 py-4 text-sm cursor-pointer whitespace-nowrap inline-block ${
									router.pathname.includes('/profile/subscriptions')
										? 'text-black border-b-[2px] border-bbx-spark -mb-[1px]'
										: 'text-gray-500 hover:text-black'
								}`}
							>
								My Subscriptions
							</span>
						</Link>

						<Link href={urls.subNav.orders.url} prefetch={false} className="relative">
							<span
								className={`px-6 py-4 text-sm cursor-pointer whitespace-nowrap inline-block ${
									router.pathname.includes('/profile/orders')
										? 'text-black border-b-[2px] border-bbx-spark -mb-[1px]'
										: 'text-gray-500 hover:text-black'
								}`}
							>
								Order History
							</span>
						</Link>

						<Link href={urls.subNav.account.url} prefetch={false} className="relative">
							<span
								className={`px-6 py-4 text-sm cursor-pointer whitespace-nowrap inline-block ${
									router.pathname.includes('/profile/account')
										? 'text-black border-b-[2px] border-bbx-spark -mb-[1px]'
										: 'text-gray-500 hover:text-black'
								}`}
							>
								Profile
							</span>
						</Link>

						<Link href={urls.subNav.favorites.url} prefetch={false} className="relative">
							<span
								className={`px-6 py-4 text-sm cursor-pointer whitespace-nowrap inline-block ${
									router.pathname === '/profile/favorites'
										? 'text-black border-b-[2px] border-bbx-spark -mb-[1px]'
										: 'text-gray-500 hover:text-black'
								}`}
							>
								Favorites
							</span>
						</Link>

						{lang !== 'en-gb' && (
							<Link href={urls.subNav.points.url} prefetch={false} className="relative">
								<span
									className={`px-6 py-4 text-sm cursor-pointer whitespace-nowrap inline-block ${
										['/profile/points', '/profile/loyalty'].includes(router.pathname)
											? 'text-black border-b-[2px] border-bbx-spark -mb-[1px]'
											: 'text-gray-500 hover:text-black'
									}`}
								>
									Points
								</span>
							</Link>
						)}
					</div>
					<button
						type="button"
						className="px-6 py-4 text-sm text-gray-500 hover:text-black whitespace-nowrap flex-shrink-0  border-l md:border-none border-gray-200"
						onClick={() => signOut()}
					>
						{lang === 'es-es' ? 'Cerrar sesión' : 'Sign Out'}
					</button>
				</nav>
			</div>
		</header>
	)
}
